import { updateUserDetailsType } from './UserDetailsConstants';

export function updateUserDetails (details) {
  return {
    type: updateUserDetailsType,
    payload: {
      details,
    },
  };
}
